
import { computed, defineComponent, ref } from "vue";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";
import PasswordField from "../passwordField/index.vue";
import { useStore } from "vuex";
import { userAPI } from "../../services/user/index";
import Button from "../button/index.vue";
import { createToastAxelerate } from "../../utils/toast";

const SettingsChangePassword = defineComponent({
  name: "SettingsChangePassword",
  components: {
    PasswordField,
    Button,
  },
  setup() {
    const store = useStore();
    const userRes = computed(() => store.state.profile.data);
    const schema = yup.object({
      current_password: yup
        .string()
        .required()
        .matches(
          /[a-z]+/,
          "Must contain at least one uppercase, lowercase,  special character and number"
        )
        .matches(
          /[A-Z]+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .matches(
          /[@$!%*#?&."'<>+-]+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .matches(
          /\d+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .min(8)
        .label("Current password"),
      new_password: yup
        .string()
        .required()
        .matches(
          /[a-z]+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .matches(
          /[A-Z]+/,
          "Must contain at least one uppercase, lowercase,  special character and number"
        )
        .matches(
          /[@$!%*#?&."'<>+-]+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .matches(
          /\d+/,
          "Must contain at least one uppercase, lowercase, special character and number"
        )
        .min(8)
        .label("New password"),
      confirm: yup
        .string()
        .oneOf([yup.ref("new_password"), null], "Passwords must match")
        .label("Confirm password"),
    });

    const { value: current } = useField("current_password");
    const { value: newPassword } = useField("new_password");
    const { value: confirm } = useField("confirm");
    const { meta, handleSubmit } = useForm({
      validationSchema: schema,
      initialValues: {
        current_password: "",
        new_password: "",
        confirm: "",
      },
    });
    const optionsLabels = [
      "A minimum of 8 characters",
      "Uppercase and lowercase letters",
      "A special character",
      "A number",
    ];
    const userFields = ref([
      {
        name: "current_password",
        model: current,
        label: "Current password",
      },
      {
        name: "new_password",
        model: newPassword,
        label: "New password",
      },
      {
        name: "confirm",
        model: confirm,
        label: "Confirm new password",
      },
    ]);
    const onSubmit = handleSubmit(async (values) => {
      const data = {
        user: {
          current_password: values.current_password,
          password: values.new_password,
          password_confirmation: values.confirm,
        },
      };
      userAPI
        .changePassword(userRes.value?.id, data)
        .then(async () => {
          createToastAxelerate(
            "Password",
            "The password has been updated.",
            "success"
          );

          await store.dispatch("getProfile");
        })
        .catch((err) => {
          createToastAxelerate(
            "Password",
            err.response.data.errors[0],
            "danger"
          );
        });
    });

    return { onSubmit, userFields, meta, optionsLabels };
  },
});
export default SettingsChangePassword;
